export const URL_BASE_PORTAL = window.location.origin;

export const BASE_URL_API = 'https://apibolao.atoscapital.us'; // URL de produção!
//export const BASE_URL_API = 'https://localhost:7058';

// Validação de reCaptcha?
export const RECAPTCHA_CHECK = false; // em produção enviar igual a true!
